export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#2E4A3A" />
      <circle
        cx="16"
        cy="16"
        r="9"
        fill="none"
        stroke="#E9C46A"
        strokeWidth="1.6"
        strokeDasharray="2 1.5"
      />
      <text
        x="16"
        y="20"
        textAnchor="middle"
        fontFamily="Fraunces, serif"
        fontStyle="italic"
        fontSize="13"
        fontWeight="500"
        fill="#E9C46A"
      >
        u
      </text>
    </svg>
  );
}
